import { computed, Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AuthStoreService {
  private _token = signal<string | null>(null);

  token = computed(() => this._token());

  isLoggedIn = computed(() => !!this._token());

  setToken(token: string) {
    this._token.set(token);
  }

  clear() {
    this._token.set(null);
  }
  
}
